import { useQuery } from '@apollo/client/react';

import { parserVersionsQuery } from '../../services/BulkReparseService';

const EMPTY_VERSIONS = [];

export const useParserVersions = (documentType, infoProvider, formatType) => {
  const enabled = Boolean(documentType && infoProvider && formatType);
  const { data, loading, error } = useQuery(parserVersionsQuery, {
    fetchPolicy: 'cache-and-network',
    skip: !enabled,
    variables: { documentType, infoProvider, formatType }
  });

  return {
    versions: enabled ? data?.versions || EMPTY_VERSIONS : EMPTY_VERSIONS,
    loading,
    error
  };
};
